import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
import { Authentication, ConfirmationResponse, SignInResponse, ResetPasswordResponse } from '../../../core';
export var AUTH_API = 'AUTH_API';
export var AuthApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(AuthApi, _AxiosApi);

  var _super = _createSuper(AuthApi);

  function AuthApi(axiosInstance) {
    var _this;

    _classCallCheck(this, AuthApi);

    _this = _super.call(this, 'auth', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(AuthApi, [{
    key: "verifyAccessToken",
    value: function () {
      var _verifyAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url, "/verify");
                _context.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", Result.ok(parsedResponseBody.data));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function verifyAccessToken(_x) {
        return _verifyAccessToken.apply(this, arguments);
      }

      return verifyAccessToken;
    }()
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/logout");
                _context2.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function signOut(_x2) {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/access-token");
                _context3.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Authentication.create(parsedResponseBody.data));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function getAccessToken(_x3) {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: "signIn",
    value: function () {
      var _signIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url, "/sign-in-web");
                _context4.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                return _context4.abrupt("return", SignInResponse.create(parsedResponseBody.data));

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 9]]);
      }));

      function signIn(_x4) {
        return _signIn.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: "signInByGoogle",
    value: function () {
      var _signInByGoogle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                url = "".concat(this.url, "/sign-in-google-web");
                _context5.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context5.sent;
                parsedResponseBody = jsonResponse.data;
                return _context5.abrupt("return", SignInResponse.fromJson(parsedResponseBody.data));

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function signInByGoogle(_x5) {
        return _signInByGoogle.apply(this, arguments);
      }

      return signInByGoogle;
    }()
  }, {
    key: "signUp",
    value: function () {
      var _signUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                url = "".concat(this.url, "/sign-up");
                _context6.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context6.sent;
                parsedResponseBody = jsonResponse.data;
                return _context6.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 9]]);
      }));

      function signUp(_x6) {
        return _signUp.apply(this, arguments);
      }

      return signUp;
    }()
  }, {
    key: "confirmation",
    value: function () {
      var _confirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                url = "".concat(this.url, "/confirmation");
                _context7.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context7.sent;
                parsedResponseBody = jsonResponse.data;
                return _context7.abrupt("return", ConfirmationResponse.create(parsedResponseBody.data));

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9]]);
      }));

      function confirmation(_x7) {
        return _confirmation.apply(this, arguments);
      }

      return confirmation;
    }()
  }, {
    key: "forgotPassword",
    value: function () {
      var _forgotPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(input) {
        var url, jsonResponse, parsedResponse;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                url = "".concat(this.url, "/forgot-password");
                _context8.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context8.sent;
                parsedResponse = jsonResponse.data;
                return _context8.abrupt("return", Result.ok(parsedResponse.message));

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 9]]);
      }));

      function forgotPassword(_x8) {
        return _forgotPassword.apply(this, arguments);
      }

      return forgotPassword;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(input) {
        var url, newPassword, token, timestamp, clientSecret, request, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                url = "".concat(this.url, "/reset-password");
                newPassword = input.newPassword, token = input.token, timestamp = input.timestamp, clientSecret = input.clientSecret;
                request = {
                  newPassword: newPassword,
                  token: token,
                  timestamp: timestamp,
                  clientSecret: clientSecret
                };
                _context9.next = 6;
                return this.axios.post(url, request);

              case 6:
                jsonResponse = _context9.sent;
                parsedResponseBody = jsonResponse.data;
                return _context9.abrupt("return", ResetPasswordResponse.create(parsedResponseBody.data));

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 11]]);
      }));

      function resetPassword(_x9) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }]);

  return AuthApi;
}(AxiosApi);